import Vue from "vue/dist/vue.esm.js";
import { common } from "../lib/common";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { ADDRGETNETWORKPARAMS } from "dns";
import VueScrollTo from "vue-scrollto";

export class caseSearchCommon {
  private vue_obj: Vue;

  constructor(elemId: string, perPage: number, jsonData: any) {
    Vue.use(VueScrollTo);
    this.vue_obj = new Vue({
      el: "#" + elemId,
      data: {
        currentDomain: "",
        refinedRows: [],
        showRows: [],
        preRows: [],
        refinedCount: 0,
        preCount: 0,
        jsonData: jsonData,
        currentPage: 0,
        data: {},
        paramsKeys: ["industries", "issues", "employees", "services"],
        formParams: { industries: [], issues: [], employees: [], services: [] },
        currentParams: {},
        formParamsStatus: {},
        resultExist: false,
        showMessage: "",
        isActiveSearch: true,
        isActiveMore: false,
        scrollOffset: -(
          document.getElementsByTagName("header")[0].clientHeight + 100
        ),
        showMoreButton: false,
      },
      created: function () {
        for (const key of this.paramsKeys) {
          this.formParams[key] = [];
        }
      },
      mounted: function () {
        this.initSearchParams();
        this.clearResult();
        this.data = this.jsonData;
        this.preSearch(this.data);
        this.execSearch();
        this.addRows();
      },
      watch: {
        formParams: {
          handler: function () {
            this.preSearch(this.data);
          },
          deep: true,
        },
      },
      methods: {
        debug: function (): void {
          console.log(this.formParams);
        },
        resetOptions: function (): void {
          for (const key of this.paramsKeys) {
            this.formParams[key] = [];
          }
          this.currentParams = this.formParams;
        },
        initSearchParams: function (): void {
          let getParams: any = common.convGetParams();
          let param: any;
          this.resetOptions();
          for (const key in getParams) {
            param = getParams[key];
            if (param) this.formParams[key] = param.split(",");
          }
          this.currentParams = this.formParams;
        },
        preSearch: function (allRows: any): string[] {
          let row: any = {};
          let matches: boolean[] = [];
          let condExists: any = {},
            sepValues: string[] = [];
          let rowCategories: string[] = [];
          let i: number = 0;
          let matchCommon = function (params: any, row: any): boolean {
            let match: boolean = true;
            if (params && params.length > 0) {
              rowCategories = [];
              if (row)
                for (let cat of row) {
                  rowCategories.push(cat);
                }
              condExists = common.arrayOR(rowCategories, params);
              match = condExists.result;
            }
            return match;
          };
          this.preRows = [];
          for (i = 0; allRows.length > i; ++i) {
            row = allRows[i];
            matches = [];
            for (const key of this.paramsKeys) {
              /*
              sepValues = [];
              for (const value of this.currentParams[key]) {
                sepValues = sepValues.concat(value.split("|"));
              }
              matches.push(matchCommon(sepValues, row[key]));
              */
              matches.push(matchCommon(this.currentParams[key], row[key]));
            }
            if (matches.indexOf(false) == -1) this.preRows.push(row.id);
          }
          this.isActiveSearch = this.preRows.length > 0;
          this.preCount = this.preRows.length;
          return this.preRows;
        },
        execSearch: function (): void {
          this.refinedRows = this.preRows;
          this.refinedCount = this.refinedRows.length;
          if (this.refinedRows.length > 0) {
            this.resultExist = true;
            this.showMessage = "";
          } else {
            this.resultExist = false;
            this.showMessage = "ご指定の条件では見つかりませんでした。";
          }
        },
        addRows: function (): void {
          let row: any = {};
          for (
            let i: number = this.currentPage * perPage;
            (this.currentPage + 1) * perPage > i && this.refinedRows[i];
            ++i
          ) {
            row = this.refinedRows[i];
            this.showRows.push(row);
          }
          /*
          this.isActiveMore = this.refinedRows.length > this.showRows.length;
          ++this.currentPage;
          */
          this.showMoreButton = this.refinedRows.length > perPage;
        },
        submitForm: function (): void {
          this.clearResult();
          this.execSearch();
          this.addRows();
          this.replaceState();
        },
        resetForm: function (): void {
          this.resetOptions();
          this.preSearch(this.data);
        },
        replaceState: function (): void {
          let selectParams: string[] = [];
          let getParams: string[] = [];
          let url: string =
            location.protocol + "//" + location.host + location.pathname;
          for (let key in this.formParams)
            if (this.formParams[key].length > 0) {
              selectParams = this.formParams[key];
              getParams.push(
                encodeURI(key) + "=" + encodeURI(selectParams.join(","))
              );
            }
          //history.replaceState('', '', ((getParams.length > 0) ? '?' + getParams.join('&') : location.pathname));
          location.href =
            getParams.length > 0 ? url + "?" + getParams.join("&") : url;
        },
        clearResult: function (): void {
          this.refinedRows = [];
          this.showRows = [];
          this.currentParams = this.formParams;
          this.currentPage = 0;
        },
      },
    });
  }
}
